export default "__VITE_ASSET__760f1129__"